import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { H1, P, Span, Spinner } from 'shared';
import { usePutServicingV1InstrumentsInstrumentIdAutopaySettingsMutation } from 'servicing-api';
import { setPaymentOption } from '../../actions';
import { DisclosureFooter } from '../../components';
import { useAuthorizationToken, useEffectiveBankAccountId, useFlexFinalizeData, useFlowPath, useSelectedBankAccount, } from '../../hooks';
import { selectors } from '../../reducer';
import { getAutopayBackRoute } from '../../utils';
import { FirstPaymentAuthorizationForm } from '../forms';
function OneTimePayment() {
    const history = useHistory();
    const dispatch = useDispatch();
    const authorizationToken = useAuthorizationToken();
    const flowPath = useFlowPath(authorizationToken);
    const { instrumentId, lenderAccountIdentifier, finalizeData, isLoading: isFinalizeLoading, } = useFlexFinalizeData(authorizationToken);
    const selectedBankAccount = useSelector((state) => selectors.selectedBankAccount(state));
    const storedPaymentOption = useSelector((state) => selectors.paymentOption(state));
    const isDI = !!finalizeData?.suggestedMonthlyPayment;
    const selectedPaymentOption = storedPaymentOption ?? (isDI ? 'suggested' : 'minimum');
    const bankAccountId = useEffectiveBankAccountId(finalizeData);
    const bankAccount = useSelectedBankAccount(lenderAccountIdentifier, bankAccountId);
    const selectedBankAccountNumber = bankAccount?.accountNumberLastFour ||
        selectedBankAccount?.accountId ||
        finalizeData?.bankAccountLast4 ||
        '';
    const bankName = bankAccount?.bankName;
    const handlePaymentOptionChange = (option) => {
        dispatch(setPaymentOption(option));
    };
    const [putAutopaySettings] = usePutServicingV1InstrumentsInstrumentIdAutopaySettingsMutation();
    const authorizeFirstPayment = async ({ paymentOption, }) => {
        if (instrumentId) {
            try {
                await putAutopaySettings({
                    instrumentId: Number(instrumentId),
                    putServicingV1InstrumentsInstrumentIdAutopaySettings: {
                        autopayEnabled: false,
                        paymentOption,
                    },
                }).unwrap();
            }
            catch (error) {
                // Continue to sign-agreement even if the call fails
            }
        }
        history.push(flowPath('/sign-agreement'));
    };
    if (isFinalizeLoading || !finalizeData) {
        return (_jsx("div", { className: "text-center", children: _jsx(Spinner, {}) }));
    }
    return (_jsxs("div", { className: "payment-authorization-container flex dir-col justify-center", children: [_jsxs("div", { className: "w100", children: [_jsx(H1, { variant: "headline-large", children: "First Payment Authorization" }), _jsx(P, { variant: "title-large", className: "payment-authorization-subtitle mar-b-0", children: "Confirm your first payment and acknowledge the manual scheduling terms." })] }), _jsx("div", { className: "autopay-auth-content flex dir-col align-center", children: _jsx(FirstPaymentAuthorizationForm, { selectedBankAccountNumber: selectedBankAccountNumber, bankName: bankName, monthlyPayment: finalizeData.monthlyPayment, suggestedMonthlyPayment: finalizeData.suggestedMonthlyPayment, estimatedFirstPaymentDate: finalizeData.estimatedFirstPaymentDate, initialPaymentOption: selectedPaymentOption, onPaymentOptionChange: handlePaymentOptionChange, handleSubmit: authorizeFirstPayment, onBack: () => history.push(flowPath(getAutopayBackRoute(finalizeData))), disclosure: _jsx(DisclosureFooter, { className: "payment-option-card__disclosure", variant: "body-medium", termLength: finalizeData.product?.termLength, loanAmount: finalizeData.loanAmount, calculatedApr: finalizeData.calculatedApr, promotionalPeriod: isDI ? finalizeData.product?.promotionalPeriod : undefined }), setUpAutopayLink: _jsx(Link, { to: flowPath('/autopay-auth'), className: "mar-t-24", children: _jsx(Span, { bold: true, variant: "body-large", className: "autopay-auth-manual-link", children: "Set Up Autopay Instead" }) }) }) })] }));
}
export default OneTimePayment;
